import React from 'react';
import { useSelector } from 'react-redux';
import { ButtonType } from '../../../../../ui/buttonTypes';
import SchoolInfo from '../../shared/SchoolInfo/SchoolInfo';
import BtnComponent from '../../../../ui/buttons/BtnComponent';
import classes from './unregisteredTeacherRegistrationStage.module.css';

const UnregisteredTeacherRegistrationStage = () => {

    const { texts } = useSelector((state) => state.translate);

    return (
        <div className={classes.unregisteredTeacherRegistrationStage}>
           <SchoolInfo />
            <div className={classes.leftSection}>
                <BtnComponent type={ButtonType.REGISTER} text={texts.btnRegister} />
                <BtnComponent type={ButtonType.REGULATIONS} text={texts.linkRegulations} className={classes.link} />
            </div>
        </div>
    );
};

export default UnregisteredTeacherRegistrationStage;

